import { Routes } from '@angular/router';

import { seoRouteData } from '../../services/seo/seo-route-data';

import { FirebaseAuthAction } from './enums/firebase-auth-action';
import { FirebaseActionGuard } from './guards/firebase-action/firebase-action.guard';
import { NoAuthGuard } from './guards/no-auth/no-auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { ResetPasswordGuard } from './router/reset-password/reset-password.guard';

export const authRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/auth/login' },
  { path: 'login', pathMatch: 'full', redirectTo: '/auth/login' },
  {
    path: 'auth/action',
    component: LoginComponent,
    canActivate: [FirebaseActionGuard],
    data: { seo: seoRouteData.accountAction },
  },
  {
    path: 'auth/verify-email',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
    data: { mode: FirebaseAuthAction.verifyAndChangeEmail, seo: seoRouteData.verifyEmail },
  },
  {
    path: 'auth',
    canActivate: [NoAuthGuard],
    loadComponent: () => import('../../layouts/card-layout/card-layout.component').then((m) => m.CardLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
        data: { seo: seoRouteData.login },
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
        data: { seo: seoRouteData.forgotPassword },
      },
      {
        path: 'reset-password',
        canActivate: [ResetPasswordGuard],
        loadComponent: () =>
          import('./pages/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
        data: { seo: seoRouteData.resetPassword },
      },
      {
        path: 'reset-password-error',
        loadComponent: () =>
          import('./pages/reset-password-error/reset-password-error.component').then(
            (m) => m.ResetPasswordErrorComponent,
          ),
        data: { seo: seoRouteData.resetPasswordError },
      },
    ],
  },
];
